<template>
	<div class="dropdown">
		<a href="#">Show languages</a>

		<div class="popup" id="toggleLanguages">
			<table>
				<tr v-for="language in languages" v-bind:key="language.id">
					<td><span class="status active"></span></td>
					<td>{{language.language}} <span v-if="language.region">({{language.region}})</span></td>
					<td><a href="#" class="btn-switch" :class="{ 'active' : language.active }" :data-toggle-lang="`${language.locale}`" v-on:click="toggleClickHandler"></a></td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>

import cms from '../modules/cms.js'
import xhrModule from '../modules/xhrModule.js'

export default {
	name: 'LangSwitch',
	props: {
		type: String,
		callback: Function,
		downloadCallback: Function
	},

	data () {
		return {
			languages: null,
			savedValue: []
		}
	},

	created () {
		this.fetchlanguages()
		var savedLangs = localStorage.getItem('cms_langswitch_' + this.type)
		if (savedLangs) this.savedValue = savedLangs.split(',')
	},

	methods: {
		render () {
			if (this.type === 'single') {
				this.findSelectedLanguage()
			} else if (this.type === 'multiple') {
				this.renderMultipleLanguages()
			}
		},

		toggleClickHandler (e) {
			var lang = e.currentTarget.getAttribute('data-toggle-lang')

			if (this.type === 'single') {
				var int = 0
				var totalLength = Object.keys(this.languages).length
				for (var key in this.languages) {
					int++
					if (this.languages[key].locale === lang) {
						this.languages[key].active = true
					} else {
						this.languages[key].active = false
					}

					if (int === totalLength) {
						this.$forceUpdate()
						this.render()

						this.saveChosenActiveLang()
					}
				}
			} else {
				this.toggleLanguage(lang)
				this.saveChosenActiveLang()
			}
		},

		toggleLanguage (lang) {
			var int = 0
			var totalLength = Object.keys(this.languages).length

			for (var key in this.languages) {
				int++
				if (this.languages[key].locale === lang) {
					if (this.languages[key].active) {
						// when this is the only active language this is not allowed
						var activeLangs = 0
						var int1 = 0
						for (var key2 in this.languages) {
							int1++
							if (this.languages[key2].active) activeLangs++
							if (int1 === totalLength) {
								if (activeLangs > 1) {
									this.languages[key].active = false
								}
							}
						}
					} else {
						this.languages[key].active = true
					}
				}

				if (int === totalLength) {
					this.$forceUpdate()
					this.render()
				}
			}
		},

		renderMultipleLanguages () {
			cms.setLanguagesDimensions(this.languages)
		},

		findSelectedLanguage () {
			// get selected language
			var activeLanguage = null
			var int = 0
			var totalLength = Object.keys(this.languages).length
			for (var key in this.languages) {
				int++
				if (this.languages[key].active) {
					activeLanguage = this.languages[key]
					this.renderSingleLanguage(activeLanguage)
					return
				}

				if (int === totalLength && !activeLanguage) {
					activeLanguage = this.languages[0]
					this.renderSingleLanguage(activeLanguage)
				}
			}
		},

		renderSingleLanguage (activeLanguage) {
			this.callback(activeLanguage)
		},

		fetchlanguages (newVal) {
			var url = '/cms/api/markets'
			xhrModule.get(url, this.getMarketsCompleteHandler.bind(this))
		},

		getMarketsCompleteHandler (data) {
			data = data.data

			if (this.downloadCallback) this.downloadCallback(data)

			// strip out the CMS language
			for (var l in data) {
				if (data[l].id === 1) delete data[l]
			}

			var int = 0
			var keys = Object.keys(data)
			var length = keys.length
			var activeFound = false
			for (var key in data) {
				int++
				if (this.savedValue.indexOf(data[key].id.toString()) > -1) {
					data[key].active = true
					activeFound = true
				} else {
					data[key].active = false
				}

				if (int === length) {
					// if nothing has been set to active we can set the first lang active
					if (!activeFound) {
						data[keys[0]].active = true
					}

					this.languages = data
					this.render()
				}
			}
		},

		saveChosenActiveLang () {
			var activeLangIDs = []
			for (var lang in this.languages) {
				if (this.languages[lang].active) {
					activeLangIDs.push(this.languages[lang].id)
				}
			}

			localStorage.setItem('cms_langswitch_' + this.type, activeLangIDs)
		}
	}
}
</script>
